import { Flex, Stack, Group, Divider, Text, NumberInput, Box, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mantine/hooks";
import { createStyles } from "@mantine/emotion";
import InfoIconWithTooltip from "../common/InfoIconWithTooltip";

const useStyles = createStyles((_theme) => ({}));

export default function DistancePrescriptionForm(props) {
  const { t } = useTranslation();
  const { theme } = useStyles();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const [editMode, setEditMode] = React.useState(false);

  const initialForm = useForm({
    initialValues: {
      distancePrescription: {
        leftEye: {
          sphere: 0,
          cylinder: 0,
        },
        rightEye: {
          sphere: 0,
          cylinder: 0,
        },
      },
    },
  });

  useEffect(() => {
    if (props.defaultValues) {
      initialForm.setValues(props.defaultValues);
    }
  }, [props.defaultValues]);

  const prescritptionNumberInput = (label, path) => {
    return (
      <NumberInput
        precision={2}
        min={-20}
        step={0.05}
        max={20}
        hideControls
        readOnly={props.defaultValues && !editMode}
        styles={{ label: { marginBottom: "0", color: "gray" } }}
        label={label}
        placeholder="+/-0.00"
        {...(props.form ? props.form.getInputProps(path) : initialForm.getInputProps(path))}
      />
    );
  };

  return (
    <Box>
      <Flex mb={"xs"} justify={"space-between"} align={"centers"}>
        <Group wrap="nowrap" gap={"xs"}>
          <Text color="dimmed">{t("NewTest.DistancePrescription")}</Text>
          <InfoIconWithTooltip
            color="yellow.5"
            size="1rem"
            tooltipText={t("NewTest.DistancePrescriptionInfo")}
            position="bottom"
          />
        </Group>

        {props.defaultValues &&
          (editMode ? (
            <Button.Group>
              <Button
                onClick={() => {
                  setEditMode(false);
                  initialForm.setValues(props.defaultValues);
                }}
                variant="subtle"
                size="xs"
                color="red"
              >
                {t("OrganizationSettings.cancel")}
              </Button>
              <Button
                variant="subtle"
                size="xs"
                onClick={() => {
                  props.saveValues(initialForm.values.distancePrescription);
                  setEditMode(false);
                }}
              >
                {t("OrganizationSettings.submit")}
              </Button>
            </Button.Group>
          ) : (
            <Button onClick={() => setEditMode(true)} variant="subtle" size="xs">
              {t("OrganizationSettings.edit")}
            </Button>
          ))}
      </Flex>

      <Flex justify={"space-between"} gap={isMobile ? "xs" : "md"} wrap="nowrap">
        <Stack gap={0} style={{ flex: 1 }}>
          <Text c={"dimmed"} fz={isMobile ? "xs" : "sm"}>
            {t("leftEye")}
          </Text>
          <Group wrap="nowrap" gap={isMobile ? "xs" : "sm"}>
            {prescritptionNumberInput(t("sphere"), "distancePrescription.leftEye.sphere")}
            {prescritptionNumberInput(t("cylinder"), "distancePrescription.leftEye.cylinder")}
          </Group>
        </Stack>
        {!isMobile && <Divider mx="sm" orientation="vertical" />}
        <Stack gap={0} style={{ flex: 1 }}>
          <Text c={"dimmed"} fz={isMobile ? "xs" : "sm"}>
            {t("rightEye")}
          </Text>
          <Group wrap="nowrap" gap={isMobile ? "xs" : "sm"}>
            {prescritptionNumberInput(t("sphere"), "distancePrescription.rightEye.sphere")}
            {prescritptionNumberInput(t("cylinder"), "distancePrescription.rightEye.cylinder")}
          </Group>
        </Stack>
      </Flex>
    </Box>
  );
}
